module.exports = __webpack_public_path__ + "static/img/logo-white.c3e364c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.png
// module id = wYO/
// module chunks = 0